import { Loading } from '@appkit4/react-components/loading'
import classnames from 'classnames'
import { flexRender } from '@tanstack/react-table'
import { Pagination } from '../Pagination/index'
import { Select } from '../Select/index'
import styles from './index.module.css'

const Download = ({ isDownloadLoading, children }) => {
    return isDownloadLoading ? (
        <Loading loadingType="circular" indeterminate={true} stopPercent={30}>
            {children}
        </Loading>
    ) : (
        <div>{children}</div>
    )
}
const SortIcon = ({ sortDirection }) => {
    switch (sortDirection) {
        case 'asc':
            return <span className="Appkit4-icon icon-sorting-ascendant-outline"></span>
        case 'desc':
            return <span className="Appkit4-icon icon-sorting-descendant-outline"></span>
        default:
            return <></>
    }
}

const Header = ({ table }) => {
    return (
        <thead className={styles.thead}>
            {table.getHeaderGroups().map((headerGroup) => {
                return (
                    <tr key={headerGroup.id} className={styles.header_row}>
                        {headerGroup.headers.map((header) => {
                            return (
                                <th
                                    key={header.id}
                                    style={{ width: header.column.getSize() }}
                                    className={styles.header_col}
                                    onClick={header.column.getToggleSortingHandler()}
                                >
                                    <div className={styles.header_col_text}>
                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                        <SortIcon sortDirection={header.column.getIsSorted()} />
                                    </div>
                                </th>
                            )
                        })}
                    </tr>
                )
            })}
        </thead>
    )
}

const Row = ({ table, onClickRow, selectedId, selectType, selectedData, disabledCheckboxList }) => {
    return (
        <>
            {table.getRowModel().rows.map((row) => {
                let disabledClassName = ''
                let selectedClassName = ''

                if (selectedId) {
                    const keyValue = row.original[selectedId]
                    const isDisabledRow = disabledCheckboxList && disabledCheckboxList.includes(keyValue)
                    disabledClassName = isDisabledRow && styles.row_disabled

                    if (selectType === 'radio') {
                        selectedClassName = selectedData === keyValue && styles.row_selected
                    }
                }

                return (
                    <tr
                        key={row.id}
                        className={classnames(styles.data_row, disabledClassName, selectedClassName)}
                        onClick={() => onClickRow(row.original)}
                    >
                        {row.getVisibleCells().map((cell) => {
                            return (
                                <td key={cell.id} className={styles.data_col}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            )
                        })}
                    </tr>
                )
            })}
        </>
    )
}

export const View = ({
    isHeader,
    children,
    data,
    noDataText,
    table,
    isTopPagination,
    isBottomPagination,
    handleChangePage,
    dataList,
    selectInputValue,
    handleChangePageSize,
    isDownload,
    isDownloadLoading,
    handleClickDownload,
    onClickRow,
    selectedId,
    selectType,
    selectedData,
    disabledCheckboxList,
    className,
    tableWrapClass,
    ...props
}) => {
    const inputProps = {
        value: selectInputValue,
        className: styles.input
    }
    return (
        <div className={classnames(styles.default, className)} {...props}>
            <div className={styles.option_wrapper}>
                <div>{children}</div>
                <div className={styles.top_option}>
                    {isTopPagination && (
                        <>
                            <Pagination
                                total={table.getPageCount() === 0 ? 1 : table.getPageCount()}
                                current={table.getState().pagination.pageIndex + 1}
                                onPageChange={handleChangePage}
                            />
                            <Select
                                width={130}
                                dataList={dataList}
                                inputProps={inputProps}
                                handleChangeSelect={handleChangePageSize}
                                selectedValue={selectInputValue}
                            />
                        </>
                    )}
                    {isDownload && (
                        <div className={styles.download_area}>
                            <Download isDownloadLoading={isDownloadLoading}>
                                <button className={styles.download} type="button" onClick={handleClickDownload}>
                                    <span className="Appkit4-icon icon-download-light-outline"></span>
                                </button>
                            </Download>
                        </div>
                    )}
                </div>
            </div>
            <div className={classnames(styles.table_wrapper, tableWrapClass)}>
                <table className={styles.table}>
                    {isHeader && <Header table={table} />}
                    <tbody>
                        <Row
                            table={table}
                            onClickRow={onClickRow}
                            selectedId={selectedId}
                            selectType={selectType}
                            selectedData={selectedData}
                            disabledCheckboxList={disabledCheckboxList}
                        />
                    </tbody>
                </table>
                {data.length === 0 && <div className={styles.no_data}>{noDataText}</div>}
            </div>
            {data.length > 0 && isBottomPagination && (
                <Pagination
                    className={styles.bottom_pagination}
                    total={table.getPageCount() === 0 ? 1 : table.getPageCount()}
                    current={table.getState().pagination.pageIndex + 1}
                    onPageChange={handleChangePage}
                />
            )}
        </div>
    )
}
